import { useMemo, useState } from "react";

export const TabComponent = ({
  tabNames,
  selectedTab,
  handleTabSwitch,
  buttonClass = "",
  parentClass = "flex-1",
  maxSize = 5,
}) => {
  const index = tabNames.indexOf(selectedTab);
  const [selectedIndex, setSelectedIndex] = useState(index !== -1 ? index : 0);

  const rows = useMemo(() => {
    if (tabNames.length <= maxSize) return [tabNames];

    const mid = Math.ceil(tabNames.length / 2);
    return [tabNames.slice(0, mid), tabNames.slice(mid)];
  }, [tabNames]);

  return (
    <div className={`${parentClass} flex flex-col gap-2 p-1 rounded-xxl bg-grey-50`}>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="flex justify-center gap-2 w-full">
          {row.map((name, index) => {
            const actualIndex = tabNames.indexOf(name);
            return (
              <div className="flex items-center w-full min-w-fit" key={index}>
                {index !== 0 &&
                  index !== row.length &&
                  actualIndex - 1 !== selectedIndex &&
                  actualIndex !== selectedIndex && (
                    <div className="w-[0.5px] h-4 mx-1 bg-grey-border"></div>
                  )}

                <button
                  key={name}
                  className={`${buttonClass} !py-2 px-3 w-full text-xs rounded-full text-center ${
                    selectedTab === name
                      ? "font-bold bg-white text-primary shadow-[#0000001F_0px_3px_8px_0px]"
                      : "font-medium bg-grey-50 text-grey-700 hover:bg-grey-200"
                  }`}
                  onClick={() => {
                    setSelectedIndex(actualIndex);
                    handleTabSwitch(name);
                  }}
                >
                  {name}
                </button>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};
